import { popoverPositionsBottom, popoverPositionsLeft, popoverPositionsRight, popoverPositionsTop, } from './positions';
export const popoverPositions = (config) => {
    const { placement } = config;
    switch (placement) {
        case 'left':
            return [...popoverPositionsLeft(config), ...popoverPositionsRight(config)];
        case 'right':
            return [...popoverPositionsRight(config), ...popoverPositionsLeft(config)];
        case 'bottom':
            return [...popoverPositionsBottom(config), ...popoverPositionsTop(config)];
        case 'top':
        default:
            return [...popoverPositionsTop(config), ...popoverPositionsBottom(config)];
    }
};
